import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import {
  getLayoutViewAuditTrackerList_action,
  getZoneData_action,
} from "../../../../actions/admin_module_action/preSetupTracker_action/layoutView_action";
import { getLayoutViewAuditTrackerList_action as getLayoutTrackerData_action } from "../../../../actions/admin_module_action/preSetupTracker_action/hallView_action";
import { getVendorTaskList_action } from "../../../../actions/vendor_module_action/vendor_task_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";
import SvgCanvas from "./SvgCanvas";
import VendorTaskDetail from "../../../vendor_module/vendor_task/vendor_task_detail";
import DailyRoutineTaskUpdate from "../../daily_routine_task/daily_routine_task_update";
import { fetchDRTList_action } from "../../../../actions/admin_module_action/daily_routine_task_action/daily_routine_task_action";

// The per-service manual forms, opened from the info icon in the booth popup -
// the same set, and the same dispatch, the Hall Manager work updation screen uses.
import FasciaForm from "../../../exhibitor_module/manual_forms/forms/fascia_Form/fascia_form";
import ExhibitorBadge from "../../../exhibitor_module/manual_forms/forms/exhibitor_badge_form/exhibitor_badge";
import ExhibitorDetails from "../../../exhibitor_module/manual_forms/forms/exhibitor_details_form/exhibitor_details";
import VisaApplication from "../../../exhibitor_module/manual_forms/forms/invitationVisaApplication/invitationVisaApplicationList";
import EDirectoryList from "../../../exhibitor_module/manual_forms/forms/e-direcory_form/e-directory_list";
import KeywordsInformation from "../../../exhibitor_module/manual_forms/forms/keywords_information_form/keywords_information";
import StallDesign from "../../../exhibitor_module/manual_forms/forms/stallDesign/stallDesign";
import AdditionalFurniture from "../../../exhibitor_module/manual_forms/forms/additional furniture/additional_furniture";
import StallPossession from "../../../exhibitor_module/manual_forms/forms/stall_possesion/stall_possesion";
import PowerConnection from "../../../exhibitor_module/manual_forms/forms/power_connection_form/power_connection";
import FreightForward from "../../../exhibitor_module/manual_forms/forms/freight_forward/freight_forward";
import Water from "../../../exhibitor_module/manual_forms/forms/water_form/water";
import AirConnectionApplication from "../../../exhibitor_module/manual_forms/forms/airConnectionApplication/airConnectionApplication";
import CarPassesApplication from "../../../exhibitor_module/manual_forms/forms/car_passes_application/car_passes_application";
import LiquareLicense from "../../../exhibitor_module/manual_forms/forms/liquare_license/liquare_license";
import LeadRetrievalConnectionApplication from "../../../exhibitor_module/manual_forms/forms/leadRetrievalConnectionApplication/leadRetrievalConnectionApplication";
import MeetingRoomRequestForm from "../../../exhibitor_module/manual_forms/forms/Meeting room request form/MeetingRoomRequestForm";
import DelegateMeeting from "../../../exhibitor_module/manual_forms/forms/delegate_meeting/delegate_meeting";
import VisitorMeetingApplication from "../../../exhibitor_module/manual_forms/forms/visitor_meeting_application/visitor_meeting_application";
import InternetConnection from "../../../exhibitor_module/manual_forms/forms/internet_connection/internet_connection";
import HousekeepingConnection from "../../../exhibitor_module/manual_forms/forms/housekeeping_connection/housekeeping_connection";
import SecurityApplication from "../../../exhibitor_module/manual_forms/forms/security_application/security_application";
import CateringServices from "../../../exhibitor_module/manual_forms/forms/catering_services/catering_services";
import HostHostessRequirements from "../../../exhibitor_module/manual_forms/forms/host_hostess_requirement/host_hostess_requirement";
import BrandingOpportunityAndAdvertisement from "../../../exhibitor_module/manual_forms/forms/brandingApportunityAndAdvertisement/brandingApportunityAndAdvertisement";
import RentalAudioAndVideoEquipment from "../../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import ExhibitorContractorBadgeApplication from "../../../exhibitor_module/manual_forms/forms/exhibitor_contractor_badgeApplication/exhibitor_contractor_badgeApplication";
import PlantAndBeautification from "../../../exhibitor_module/manual_forms/forms/PlantAndBeautification/PlantAndBeautification";
import RentalAudioAndVedioEquipment from "../../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import {
  buildStallHomes,
  cleanServicePartnerRows,
  otherAreaHallKeys,
  cleanExhibitorOrderRows,
  cleanPossessionRows,
} from "./trackerData";
// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class LayoutView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      // Multi-mode filters and SP 4-dataset states
      viewFilter: "stall", // "stall" | "zone" | "hall"
      dataFilters: ["service_partner", "exhibitor_orders", "daily_routine"],
      hallZoneMasterRows: [], // result set 0 (data): Halls & Zones master
      stallHomes: new Map(), // stall -> real hall/zone, from data2's stall master rows
      servicePartnerRows: [], // result set 1 (data1): Service Partner tasks
      exhibitorOrderRows: [], // result set 2 (data2): Exhibitor orders / services
      dailyRoutineRows: [], // result set 3 (data3): Daily routine tasks
      stallPossessionRows: [], // result set 4 (data4): Stall possession, one row per exhibitor per stall
      // Raw rows from getHallViewAuditTrackerList - backwards compatibility
      taskRows: [],
      exhibitorRows: [],
      isTaskLoading: true,
      // Set when the tracker call itself fails, so the popup can say "the
      // request failed" instead of "there are no rows" - they looked identical
      // and sent us hunting in the wrong place.
      taskLoadError: null,
      // Layout SVG related states
      layouts: [],
      selectedLayoutId: null,
      // Layouts whose drawing is being fetched (loadLayoutSvg).
      svgLoadingIds: [],
      // All layouts are shown stacked: each one's halls/booths as read from its
      // drawing, and each one's legend counts (summed in the shared legend).
      svgDataByLayout: {},
      // The layout whose drawing may be inserted now (after "Preparing...").
      renderReadyId: null,
      // A large drawing waiting for the user's go-ahead.
      largeSvgPrompt: null,
      // A hall picked from another layout, focused once that drawing is read.
      pendingHall: null,
      // "All Halls": every layout stacked, one below the other.
      showAllLayouts: false,
      statusCountsByLayout: {},
      layoutError: null,
      isLayoutLoading: true,
      // Hall & Booth filter states for auto-zoom
      filterHallId: "",
      filterBoothId: "",
      // Halls/booths parsed out of the layout SVG
      svgHalls: [],
      svgBooths: [],
      // Zone data for the selected hall (data = zones, data2 = stalls per zone)
      zoneData: [],
      zoneStalls: [],
      selectedZoneId: "",
      isZoneLoading: false,
      zoneError: null,
      // Only the Organizer verifies, the same rule the vendor task screen applies.
      // sp_get_hallviewauditTracker does not carry the verification columns, so the
      // state is read from the task API and merged onto the tracker rows by
      // ExhVendorPlanDtlID - that also brings the plan header id a save needs
      // Super Admin and Admin both, the same pair treated as the Organizer team by
      // the task notifications. Both session stores are used for the role across
      // this codebase and neither is set on every route, so whichever one answers
      // decides
      isOrganizer: [
        sessionStorage.getItem("RoleIDSS"),
        JSON.parse(sessionStorage.getItem("loginDataSS") || "{}").RoleID,
      ].some((role) => role == 6 || role == 2),
      // The Hall Manager verifies one step before the Organizer. Read from both
      // session stores for the same reason isOrganizer is.
      isHallManagerRole: [
        sessionStorage.getItem("RoleIDSS"),
        JSON.parse(sessionStorage.getItem("loginDataSS") || "{}").RoleID,
      ].some((role) => role == 16),
      verificationById: {},
      deliverableRows: [],
      // The task screen, opened over the map with this booth's rows filtered in
      showTaskModal: false,
      taskModalFilter: null,
      // Daily routine opened from a popup, edited in the DailyRoutineTaskUpdate
      // screen: { row, loading, occurrences, pick, error }.
      routineModal: null,
      // The manual form behind the info icon against each service
      isManualFormModalOpen: false,
      manualFormService: null,
      manualFormExhibitor: null,
    };

    this.loadLayouts = this.loadLayouts.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");
    this.getVendorTaskList();
    this.loadDeliverables();
    this.loadLayouts();
  }

  // The service partners' deliverables and checklist sub points, from the
  // vendor task SP (sp_get_ExhVendorTaskDetails) - the tracker SP carries only
  // one row per task, with no deliverables. VendorID null = every vendor,
  // StatusID 3 = all statuses, the same call the vendor task screen makes.
  loadDeliverables = () => {
    this.props
      .getVendorTaskList_action("", 3)
      .then((res) => {
        const rows = res && res.error != 1 && res.data ? res.data.vendorPlanList || [] : [];
        this.setState({ deliverableRows: rows });
      })
      .catch((err) => {
        console.error("[layoutView] deliverables failed:", err);
        this.setState({ deliverableRows: [] });
      });
  };

  // The row carries IsCompleted: null so verifying never rewrites the completion
  // this screen read a moment ago - the same shape the vendor task screen sends
  // sp_get_hallviewauditTracker carries neither IsHallManagerApprove, the sub
  // points, the remarks, the attachments nor the approval stamps, so the popup
  // cannot honestly show the task screen's full set of columns. Rather than a
  // half-built copy, hand the organizer over to that screen with this booth's
  // hall / service / service partner already filtered in.
  // Driven by the toolbar, not by a booth. Whatever Hall and Service are
  // selected on the map is what the task list opens on - the SVG hall id and the
  // ServiceID are both resolved to the display names that screen filters by.
  // Same contract as work_updation.js: the form components read the
  // registration id out of sessionStorage, so it has to be set before the modal
  // mounts rather than passed as a prop.
  handleOpenManualForm = (serviceName, exhRegistrationID, exhibitorName) => {
    if (exhRegistrationID == null) return;
    sessionStorage.setItem("ExhRegistrationIDSS", exhRegistrationID);
    this.setState({
      isManualFormModalOpen: true,
      manualFormService: serviceName,
      manualFormExhibitor: exhibitorName || null,
    });
  };

  renderManualForm(ServiceName) {
    if (ServiceName === "Fascia") {
      return <FasciaForm />;
    } else if ((ServiceName || "").trim() === "Exhibitor Paid Badges") {
      return <ExhibitorBadge />;
    } else if ((ServiceName || "").trim() === "exhibitorDetails") {
      return <ExhibitorDetails />;
    } else if ((ServiceName || "").trim() === "Visa Application  ") {
      return <VisaApplication />;
    } else if ((ServiceName || "").trim() === "edirectoryList") {
      return <EDirectoryList />;
    } else if ((ServiceName || "").trim() === "Keywords") {
      return <KeywordsInformation />;
    } else if ((ServiceName || "").trim() === "Stall Design") {
      return <StallDesign />;
    } else if ((ServiceName || "").trim() === "Furniture") {
      return <AdditionalFurniture />;
    } else if ((ServiceName || "").trim() === "Stall Possession") {
      return <StallPossession />;
    } else if ((ServiceName || "").trim() === "Power") {
      return <PowerConnection />;
    } else if ((ServiceName || "").trim() === "Freight Forwarders") {
      return <FreightForward />;
    } else if ((ServiceName || "").trim() === "Water") {
      return <Water />;
    } else if ((ServiceName || "").trim() === "Air") {
      return <AirConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Car Passes") {
      return <CarPassesApplication />;
    } else if (ServiceName === "Liquor License") {
      return <LiquareLicense />;
    } else if ((ServiceName || "").trim() === "Lead Retrieval") {
      return <LeadRetrievalConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Meeting Room") {
      return <MeetingRoomRequestForm />;
    } else if ((ServiceName || "").trim() === "delegateMeeting") {
      return <DelegateMeeting />;
    } else if ((ServiceName || "").trim() === "visitorMeetingApplication") {
      return <VisitorMeetingApplication />;
    } else if ((ServiceName || "").trim() === "Internet Connection") {
      return <InternetConnection />;
    } else if ((ServiceName || "").trim() === "Housekeeping") {
      return <HousekeepingConnection />;
    } else if ((ServiceName || "").trim() === "Security") {
      return <SecurityApplication />;
    } else if ((ServiceName || "").trim() === "Catering") {
      return <CateringServices />;
    } else if ((ServiceName || "").trim() === "Host and Hostess") {
      return <HostHostessRequirements />;
    } else if ((ServiceName || "").trim() === "Branding Opportunity  ") {
      return <BrandingOpportunityAndAdvertisement />;
    } else if ((ServiceName || "").trim() === "AV Equipments ") {
      return <RentalAudioAndVideoEquipment />;
    } else if ((ServiceName || "").trim() === "Contractor Badge  ") {
      return <ExhibitorContractorBadgeApplication />;
    } else if ((ServiceName || "").trim() === "plantAndBeautification") {
      return <PlantAndBeautification />;
    } else {
      return null; // or <NotFound />
    }
  }

  // A daily routine row from a popup (tracker result set: one row per program
  // per hall) -> the Daily Routine Task update screen, in edit mode. That screen
  // works on ONE occurrence (date x schedule time), which the tracker row does
  // not carry, so the occurrences are read from the task list API for the
  // program's own date range and hall, matched on the checklist header, and the
  // one for today (the running slot, else the next) is opened; the modal lets
  // the user switch to any other.
  handleOpenDailyRoutine = (row) => {
    if (!row || row.DailyRoutineChecklistHdrID == null) return;
    this.setState({ routineModal: { row, loading: true, occurrences: [], pick: 0, error: null } });
    const norm = (v) => String(v ?? "").trim().toLowerCase();
    this.props
      .fetchDRTList_action(row.ProgramTitle || "", row.FromDate || "", row.ToDate || "", row.HallID ?? "", "")
      .then((data) => {
        const current = this.state.routineModal;
        if (!current || current.row !== row) return; // closed or replaced meanwhile
        const all = data && data.error != 1 && Array.isArray(data.data) ? data.data : [];
        const occurrences = all
          .filter((o) => String(o.DailyRoutineChecklistHdrID) === String(row.DailyRoutineChecklistHdrID))
          .filter((o) => !row.HallName || norm(o.HallName) === norm(row.HallName))
          .sort((a, b) =>
            moment(a.ChecklistDate).valueOf() - moment(b.ChecklistDate).valueOf() ||
            String(a.FromTime || "").localeCompare(String(b.FromTime || "")));
        this.setState({
          routineModal: {
            ...current,
            loading: false,
            occurrences,
            pick: this.defaultRoutineOccurrence(occurrences),
            error: data && data.error == 1 ? "Could not load this routine's schedule." : null,
          },
        });
      })
      .catch(() => {
        const current = this.state.routineModal;
        if (!current || current.row !== row) return;
        this.setState({ routineModal: { ...current, loading: false, error: "Could not load this routine's schedule." } });
      });
  };

  // Today's occurrence - the slot running now, else the next one today, else
  // today's last; with none today, the nearest date.
  defaultRoutineOccurrence = (occurrences) => {
    if (!occurrences || occurrences.length === 0) return 0;
    const now = moment();
    const nowHm = now.format("HH:mm");
    const today = occurrences
      .map((o, i) => ({ o, i }))
      .filter(({ o }) => moment(o.ChecklistDate).isSame(now, "day"));
    if (today.length > 0) {
      const running = today.find(({ o }) => String(o.FromTime || "") <= nowHm && nowHm <= String(o.ToTime || o.FromTime || ""));
      const next = today.find(({ o }) => String(o.FromTime || "") > nowHm);
      return (running || next || today[today.length - 1]).i;
    }
    let best = 0;
    occurrences.forEach((o, i) => {
      if (Math.abs(moment(o.ChecklistDate).diff(now)) < Math.abs(moment(occurrences[best].ChecklistDate).diff(now))) best = i;
    });
    return best;
  };

  routineStateOf = (o) => ({
    DailyRoutineChecklistHdrID: o.DailyRoutineChecklistHdrID,
    DailyRoutineChecklistHallID: o.DailyRoutineChecklistHallID,
    DailyRoutineChecklistDateID: o.DailyRoutineChecklistDateID,
    DailyRoutineChecklistScheduleTimeID: o.DailyRoutineChecklistScheduleTimeID,
    name: o.ProgramTitle,
    datestr: o.ChecklistDate ? moment(o.ChecklistDate).format("DD/MM/YYYY") : "",
    timestr: `${o.FromTime || ""} - ${o.ToTime || ""}`,
    hallstr: o.HallName,
    isView: false, // edit mode: status + remark per checklist item
  });

  // Saved -> reload the tracker so the routine's status on the map follows.
  closeRoutineModal = (saved) => {
    this.setState({ routineModal: null }, () => {
      if (saved === true) this.getVendorTaskList();
    });
  };

  // rowFilter: from a service partner row in the booth popup -
  // { hallName, vendorCompany, serviceName } - opens the same Tasks popup
  // narrowed to that row. Without it, the header button's toolbar filters.
  handleOpenTaskDetail = (rowFilter) => {
    if (rowFilter && typeof rowFilter === "object" && !rowFilter.nativeEvent) {
      const { serviceList, svgHalls } = this.state;
      const rowHall = (svgHalls || []).find((h) => h.HallName === rowFilter.hallName);
      const service = rowFilter.serviceName
        ? (serviceList || []).find((svc) =>
          [svc.Name, svc.DisplayName].some((n) => String(n || "").trim().toLowerCase() === String(rowFilter.serviceName).trim().toLowerCase()))
        : null;
      this.setState({
        showTaskModal: true,
        taskModalFilter: {
          hallName: rowFilter.hallName || null,
          serviceName: rowFilter.serviceName || null,
          vendorCompany: rowFilter.vendorCompany || null,
          status: "all",
          hallDbId: rowHall ? this.resolveDbHallId(rowHall.HallID) : null,
          serviceId: service ? service.ServiceID : null,
        },
      });
      return;
    }
    const { filterHallId, serviceId, svgHalls, serviceList } = this.state;

    const hall = svgHalls.find((h) => h.HallID === filterHallId);
    const service = (serviceList || []).find(
      (svc) => String(svc.ServiceID) === String(serviceId)
    );

    this.setState({
      showTaskModal: true,
      taskModalFilter: {
        hallName: hall ? hall.HallName : null,
        serviceName: service ? service.Name || service.DisplayName : null,
        // The toolbar has no service-partner filter, so that one stays open.
        vendorCompany: null,
        status: "all",
        // Kept for matching the exhibitor list - ids don't suffer the spelling
        // differences the display strings do.
        hallDbId: hall ? this.resolveDbHallId(hall.HallID) : null,
        serviceId: service ? service.ServiceID : null,
      },
    });
  };

  // Closing unmounts the screen, which stops its 15s poll and drops its state -
  // reopening on another booth then starts clean rather than showing the last
  // booth's rows for a beat.
  closeTaskModal = () => {
    this.setState({ showTaskModal: false, taskModalFilter: null }, () => {
      // Verifications made in there are the point of opening it, so pick them up
      this.getVendorTaskList();
      this.loadDeliverables();
    });
  };

  loadLayouts() {
    const exhibitionId = sessionStorage.getItem('sessionExhibitionID');

    if (!exhibitionId) {
      this.setState({ layoutError: "Exhibition ID not found", isLayoutLoading: false });
      return;
    }

    // The list only - each layout's drawing is fetched when it is shown
    // (loadLayoutSvg); one response with every drawing grew past 80 MB.
    this.setState({ isLayoutLoading: true, layoutError: null });
    this.props
      .getLayoutViewAuditTrackerList_action(exhibitionId, null, false)
      .then((res) => {
        if (res && res.data && res.error === 0) {
          const layouts = res.data.map(layout => {
            // Derive halls from booths if halls array is empty/missing
            if ((!layout.halls || layout.halls.length === 0) && layout.booths && layout.booths.length > 0) {
              const hallMap = {};
              layout.booths.forEach(booth => {
                const hId = booth.HallId || booth.HallID;
                const hName = booth.HallName;
                if (hId && hName && !hallMap[hId]) {
                  hallMap[hId] = { HallID: hId, HallName: hName };
                }
              });
              layout.halls = Object.values(hallMap);
            }
            return layout;
          });
          const firstId = layouts.length > 0 ? layouts[0].MstHallLayoutID : null;
          this.setState({
            layouts,
            isLayoutLoading: false,
            selectedLayoutId: firstId,
            layoutError: null,
          }, () => this.selectLayout(firstId));
        } else {
          this.setState({
            isLayoutLoading: false,
            layoutError: res?.msg || "Failed to load layouts",
          });
        }
      })
      .catch((err) => {
        console.error("Error loading layouts:", err);
        this.setState({
          isLayoutLoading: false,
          layoutError: "Error loading layouts",
        });
      });
  }

  // ─── One layout at a time, chosen by hall ───
  // Each layout holds a few halls (HallLayoutMapping, returned as layout.halls).
  // Picking a hall shows the layout that has it; only that drawing is fetched
  // and only that one is in the page.
  //
  // Keeping the page responsive: inserting a drawing and reading its booths is
  // synchronous and a large one freezes the tab while it runs, so
  //   - every drawing loads straight away ("Loading Layout..." while it downloads),
  //   - a "Preparing..." state is painted before the drawing goes in,
  //   - a response for a layout no longer selected is ignored, and
  //   - large drawings of other layouts are dropped from memory.
  LARGE_SVG_BYTES = 40 * 1024 * 1024;
  svgRequestSeq = 0;
  latestSvgRequest = {};

  selectLayout = (layoutId, pendingHallName = null) => {
    if (layoutId == null) return;
    const switching = layoutId !== this.state.selectedLayoutId || !this.state.renderReadyId || this.state.showAllLayouts;
    this.setState((s) => ({
      selectedLayoutId: layoutId,
      showAllLayouts: false,
      pendingHall: pendingHallName ? { layoutId, name: pendingHallName } : null,
      ...(switching
        ? {
          renderReadyId: s.renderReadyId === layoutId ? layoutId : null,
          largeSvgPrompt: null,
          filterHallId: "",
          filterBoothId: "",
          selectedZoneId: "",
          zoneData: [],
          zoneStalls: [],
          zoneError: null,
          isZoneLoading: false,
          // Drop big drawings that are no longer shown; small ones stay cached.
          layouts: s.layouts.map((l) =>
            l.MstHallLayoutID !== layoutId && l.svgContent && l.svgFileSize > this.LARGE_SVG_BYTES
              ? { ...l, svgContent: null }
              : l
          ),
        }
        : {}),
    }), () => {
      const layout = this.state.layouts.find((l) => l.MstHallLayoutID === layoutId);
      if (!layout) return;
      if (layout.svgContent) {
        if (this.state.renderReadyId !== layoutId) this.markRenderReady(layoutId);
        else this.resolvePendingHall();
      } else {
        this.loadLayoutSvg(layoutId);
      }
    });
  };

  // Paint the "Preparing..." state first, then insert the drawing.
  markRenderReady = (layoutId) => {
    const go = () => {
      if (this.state.selectedLayoutId === layoutId) this.setState({ renderReadyId: layoutId });
    };
    if (typeof window !== "undefined" && window.requestAnimationFrame) {
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => setTimeout(go, 30)));
    } else {
      setTimeout(go, 50);
    }
  };

  // Fetches one layout's drawing and merges it into the list.
  loadLayoutSvg = (layoutId) => {
    if (layoutId == null) return Promise.resolve();
    const current = this.state.layouts.find((l) => l.MstHallLayoutID === layoutId);
    if (!current || current.svgFileExists === false) return Promise.resolve();
    if (current.svgContent) { this.markRenderReady(layoutId); return Promise.resolve(); }
    // Large drawings load straight away too (no "Load drawing" click); the
    // "Loading Layout..." state shows while it downloads.
    if ((this.state.svgLoadingIds || []).includes(layoutId)) return Promise.resolve();

    const exhibitionId = sessionStorage.getItem('sessionExhibitionID');
    const token = ++this.svgRequestSeq;
    this.latestSvgRequest[layoutId] = token;
    this.setState((s) => ({
      svgLoadingIds: [...(s.svgLoadingIds || []), layoutId],
      // Only this layout's prompt - with All Halls another one may be waiting.
      largeSvgPrompt: s.largeSvgPrompt === layoutId ? null : s.largeSvgPrompt,
      layoutError: null,
    }));
    const finish = (svgContent, booths, error) => {
      if (this.latestSvgRequest[layoutId] !== token) return; // superseded
      const stillShown = this.state.selectedLayoutId === layoutId || this.state.showAllLayouts;
      // A big drawing nobody is looking at any more is not worth holding.
      const keep = svgContent && (stillShown || (current.svgFileSize || 0) <= this.LARGE_SVG_BYTES);
      this.setState((s) => ({
        svgLoadingIds: (s.svgLoadingIds || []).filter((id) => id !== layoutId),
        layouts: keep
          ? s.layouts.map((l) => (l.MstHallLayoutID === layoutId ? { ...l, svgContent, booths: booths || l.booths } : l))
          : s.layouts,
        layoutError: error && stillShown ? error : s.layoutError,
      }), () => {
        if (keep && stillShown) this.markRenderReady(layoutId);
      });
    };

    return this.props
      .getLayoutViewAuditTrackerList_action(exhibitionId, layoutId, true)
      .then((res) => {
        const loaded = res && res.error === 0 && Array.isArray(res.data)
          ? res.data.find((l) => l.MstHallLayoutID === layoutId)
          : null;
        if (loaded && loaded.svgContent) finish(loaded.svgContent, loaded.booths);
        else finish(null, null, `The drawing for "${current.LayoutName}" could not be loaded.`);
      })
      .catch((err) => {
        console.error("Error loading layout drawing:", err);
        finish(null, null, `The drawing for "${current.LayoutName}" could not be loaded.`);
      });
  };

  // A hall picked before its layout was on screen: focus it once the drawing
  // has been read (its id is only known from the drawing).
  resolvePendingHall = () => {
    const { pendingHall, selectedLayoutId, svgDataByLayout } = this.state;
    if (!pendingHall || pendingHall.layoutId !== selectedLayoutId) return;
    const data = svgDataByLayout[selectedLayoutId];
    if (!data) return;
    const key = String(pendingHall.name || "").trim().toLowerCase();
    const hall = (data.halls || []).find((h) => String(h.HallName || "").trim().toLowerCase() === key);
    this.setState({ pendingHall: null }, () => {
      if (hall) this.handleFilterHallChange(hall.HallID);
    });
  };

  handleLayoutSelect = (layoutId) => {
    this.setState({
      selectedLayoutId: layoutId,
      filterHallId: "",
      filterBoothId: "",
      zoneData: [],
      zoneStalls: [],
      selectedZoneId: "",
      zoneError: null,
      isZoneLoading: false,
    }, () => this.loadLayoutSvg(layoutId));
  };

  // The hall dropdown carries SVG-derived ids ("H1", "H3") because the drawing
  // is the source of truth for what can be selected. The zone API needs the
  // database HallId, so resolve across on hall name — the one field both sides
  // agree on. Prefer the master hall list; fall back to the layout payload.
  resolveDbHallId = (svgHallId) => {
    const { svgHalls, hallList, layouts } = this.state;
    const hall = svgHalls.find((h) => h.HallID === svgHallId);
    if (!hall) return null;

    const key = String(hall.HallName || "").trim().toLowerCase();
    const match = (hallList || []).find(
      (h) => String(h.HallName || "").trim().toLowerCase() === key
    );
    if (match) return match.HallId != null ? match.HallId : match.HallID;

    // Any layout's payload - the hall may be on any of the stacked layouts.
    const apiHall = (layouts || [])
      .flatMap((l) => l.halls || [])
      .find((h) => String(h.HallName || "").trim().toLowerCase() === key);
    return apiHall ? (apiHall.HallID != null ? apiHall.HallID : apiHall.HallId) : null;
  };

  // "All Halls": every layout, one below the other. Drawings are fetched one
  // after another; a large one still waits for its "Load drawing" click, so
  // picking All Halls cannot freeze the page unannounced.
  showAllLayouts = () => {
    const firstId = this.state.layouts.length ? this.state.layouts[0].MstHallLayoutID : null;
    this.setState({
      showAllLayouts: true,
      selectedLayoutId: firstId,
      pendingHall: null,
      largeSvgPrompt: null,
      filterHallId: "",
      filterBoothId: "",
      selectedZoneId: "",
      zoneData: [],
      zoneStalls: [],
      zoneError: null,
      isZoneLoading: false,
    }, async () => {
      for (const l of this.state.layouts) {
        if (!this.state.showAllLayouts) break; // left All Halls meanwhile
        // eslint-disable-next-line no-await-in-loop
        await this.loadLayoutSvg(l.MstHallLayoutID);
      }
    });
  };

  statusCountCallbacks = {};
  statusCountCallbackFor = (layoutId) => {
    if (!this.statusCountCallbacks[layoutId]) {
      this.statusCountCallbacks[layoutId] = (counts) => {
        this.setState((s) => ({ statusCountsByLayout: { ...s.statusCountsByLayout, [layoutId]: counts } }));
      };
    }
    return this.statusCountCallbacks[layoutId];
  };

  // Records a drawing's halls/booths once read (stable callback per layout,
  // so SvgCanvas is not handed a new one on every render).
  svgDataCallbacks = {};
  svgDataCallbackFor = (layoutId) => {
    if (!this.svgDataCallbacks[layoutId]) {
      this.svgDataCallbacks[layoutId] = ({ halls, booths }) => {
        this.setState((s) => {
          const svgDataByLayout = { ...s.svgDataByLayout, [layoutId]: { halls: halls || [], booths: booths || [] } };
          const shown = s.selectedLayoutId === layoutId;
          return {
            svgDataByLayout,
            ...(shown ? { svgHalls: halls || [], svgBooths: booths || [] } : {}),
          };
        }, () => this.resolvePendingHall());
      };
    }
    return this.svgDataCallbacks[layoutId];
  };

  handleFilterHallChange = (hallId) => {
    if (hallId === "all") {
      this.showAllLayouts();
      return;
    }
    // A layout entry: the whole drawing. On screen already -> just clear the
    // hall; otherwise (or from All Halls) switch to that layout, no hall picked.
    if (typeof hallId === "string" && hallId.startsWith("layout:")) {
      const layoutId = Number(hallId.slice("layout:".length));
      if (layoutId !== this.state.selectedLayoutId || this.state.showAllLayouts) {
        this.selectLayout(layoutId);
        return;
      }
      hallId = "";
    }
    // A hall of a layout that is not on screen: switch to that layout first.
    if (typeof hallId === "string" && hallId.startsWith("pending:")) {
      const [, layoutId, ...rest] = hallId.split(":");
      this.selectLayout(Number(layoutId), rest.join(":"));
      return;
    }
    // A zone belongs to one hall. Left in state, a stale selectedZoneId from
    // the PREVIOUS hall silently restricted the freshly-picked hall down to
    // whatever that old zone id happened to also match (or to nothing) -
    // "wrong focusing" on the very next click. Cleared here, synchronously,
    // rather than waiting on getZoneData's async reset, which left exactly
    // that window open.
    this.setState({ filterHallId: hallId, filterBoothId: "", selectedZoneId: "" }, () => {
      this.getZoneData(hallId);
    });
  };

  handleZoneChange = (zoneId) => {
    this.setState({ selectedZoneId: zoneId, filterBoothId: "" });
  };

  // A stall clicked directly on the Zone Status / Hall Status map (as opposed
  // to picked from the dropdowns) can belong to a hall other than the one
  // currently selected - or to none at all, in views that show every hall's
  // zones at once. Both the hall AND the zone are set together here, in one
  // update, so the map never briefly frames the zone against the WRONG
  // (previous) hall's booths while the two dropdowns catch up with each
  // other one at a time.
  handleZoneStallFocus = (hallId, zoneId) => {
    this.setState({ filterHallId: hallId, filterBoothId: "", selectedZoneId: zoneId }, () => {
      // Refreshes zoneData/zoneStalls (and the Zone dropdown's options) for
      // the clicked stall's hall, but keeps the zone we just set instead of
      // clearing it back to "" the way a plain hall change does.
      this.getZoneData(hallId, zoneId);
    });
  };

  // getVendorTaskList already forwards serviceId to the API, so filtering
  // server-side keeps the legend counts and the popup's service list
  handleViewFilterChange = (viewFilter) => {
    this.setState({ viewFilter });
  };

  handleDataFilterChange = (dataFilters) => {
    this.setState({ dataFilters });
  };

  // Frontend-filtered service selection
  handleServiceChange = (serviceId) => {
    this.setState({ serviceId });
  };

  // Task/vendor/exhibitor detail for the booth popup.
  // sp_get_hallviewauditTracker returns 4 result sets:
  // 0: Master Hall & Zone mapping (data)
  // 1: Service Partner Tasks (data1)
  // 2: Exhibitor Orders & Services (data2)
  // 3: Daily Routine Checklist Tasks (data3)
  async getVendorTaskList() {
    this.setState({ isTaskLoading: true });
    try {
      const res = await this.props.getLayoutTrackerData_action(
        "", "", "", "", "", "", "", ""
      );
      if (!res || res.error === 1) {
        const msg = (res && (res.msg || res.errormsg)) || "no response";
        console.error("[layoutView] tracker call failed:", msg, res);
        this.setState({
          hallZoneMasterRows: [],
          stallHomes: new Map(),
          servicePartnerRows: [],
          exhibitorOrderRows: [],
          dailyRoutineRows: [],
          stallPossessionRows: [],
          taskRows: [],
          exhibitorRows: [],
          isTaskLoading: false,
          taskLoadError: `Tracker request failed: ${msg}`,
        });
        return;
      }

      // Collect candidate result sets from various response layouts
      const candidates = [];
      const collect = (value) => {
        if (!Array.isArray(value) || value.length === 0) return;
        if (Array.isArray(value[0])) {
          value.forEach(collect);
          return;
        }
        if (typeof value[0] === "object") candidates.push(value);
      };
      collect(res.data);
      collect(res.data1);
      collect(res.data2);
      collect(res.data3);
      collect(res.data4);

      const hasField = (rows, field) =>
        rows.some((row) => row && row[field] != null);

      // Result set 0 (data): Master Halls & Zones
      let hallZoneMasterRows =
        (Array.isArray(res.data) && typeof res.data[0] === "object" && res.data[0].ZoneID != null && res.data[0].HallID != null)
          ? res.data
          : candidates.find((rows) => hasField(rows, "ZoneID") && hasField(rows, "HallID") && !hasField(rows, "VendorCompanyName") && !hasField(rows, "HMWorkupdationID")) || [];

      // Result set 1 (data1): Service Partner Tasks
      let servicePartnerRows =
        (Array.isArray(res.data1) && typeof res.data1[0] === "object")
          ? res.data1
          : candidates.find((rows) => hasField(rows, "VendorCompanyName") || hasField(rows, "StallTaskStatus")) || [];

      // Result set 2 (data2): Exhibitor Orders & Services
      let exhibitorOrderRows =
        (Array.isArray(res.data2) && typeof res.data2[0] === "object")
          ? res.data2
          : candidates.find((rows) => rows !== servicePartnerRows && (hasField(rows, "HMWorkupdationID") || hasField(rows, "AccoundID") || hasField(rows, "StallPossessionStatusID"))) || [];

      // Result set 3 (data3): Daily Routine Tasks
      let dailyRoutineRows =
        (Array.isArray(res.data3) && typeof res.data3[0] === "object")
          ? res.data3
          : candidates.find((rows) => hasField(rows, "DailyRoutineChecklistHdrID") || hasField(rows, "ProgramTitle")) || [];

      // data1 is fanned out across every hall and data2 mixes stall master
      // rows with orders; see trackerData.js. Clean both once, here.
      const rawCounts = { data1: servicePartnerRows.length, data2: exhibitorOrderRows.length };
      const stallHomes = buildStallHomes(exhibitorOrderRows);
      // Other areas (no booths) keep their area-level tasks, which have no stall.
      servicePartnerRows = cleanServicePartnerRows(servicePartnerRows, stallHomes, otherAreaHallKeys(hallZoneMasterRows));
      exhibitorOrderRows = cleanExhibitorOrderRows(exhibitorOrderRows);

      // Result set 4 (data4): Stall possession - status per exhibitor per stall.
      const rawPossessionRows =
        (Array.isArray(res.data4) && typeof res.data4[0] === "object")
          ? res.data4
          : candidates.find((rows) => hasField(rows, "PendingChecklist") && hasField(rows, "StallPossessionStatusID")) || [];
      const stallPossessionRows = cleanPossessionRows(rawPossessionRows);

      const legacyTaskRows = candidates.find((rows) => hasField(rows, "ExhVendorPlanDtlID")) || servicePartnerRows;
      const legacyExhibitorRows = servicePartnerRows.length > 0 ? servicePartnerRows : (candidates.find((rows) => hasField(rows, "ExhRegistrationID")) || []);

      console.info(
        "[layoutView] 4 result sets loaded:",
        "Master Halls/Zones:", hallZoneMasterRows.length,
        "| Service Partner Tasks:", servicePartnerRows.length, `(raw ${rawCounts.data1})`,
        "| Exhibitor Orders:", exhibitorOrderRows.length, `(raw ${rawCounts.data2})`,
        "| Stalls placed:", stallHomes.size,
        "| Daily Routine:", dailyRoutineRows.length,
        "| Stall Possession:", stallPossessionRows.length, `(raw ${rawPossessionRows.length})`
      );

      const flagOn = (v) => {
        const x = Array.isArray(v) ? v.find((i) => i != null) : v;
        return x === 1 || x === true;
      };
      const verificationById = {};
      legacyTaskRows.forEach((t) => {
        const id = t.ExhVendorPlanDtlID || t.HMWorkupdationID;
        if (id == null || verificationById[id]) return;
        verificationById[id] = {
          ExhVendorPlanHdrID: t.ExhVendorPlanHdrID,
          IsAdminApprove: flagOn(t.IsAdminApprove || t.IsVerifyByOrganizer),
          IsHallManagerApprove: flagOn(t.IsHallManagerApprove || t.IsVerifyByHallManager),
          AdminApprovalDateTime: t.AdminApprovalDateTime || t.IsVerifyByOrganizerDateTime || null,
          HallManagerApprovalDateTime: t.HallManagerApprovalDateTime || t.IsVerifyByHallManagerDateTime || null,
          IsCompleted: flagOn(t.IsCompleted || (t.IsVerifyByOrganizer && t.IsVerifyByHallManager)),
          CompletionDateTime: t.CompletionDateTime || null,
        };
      });

      this.setState({
        hallZoneMasterRows,
        stallHomes,
        servicePartnerRows,
        exhibitorOrderRows,
        dailyRoutineRows,
        stallPossessionRows,
        taskRows: legacyTaskRows,
        exhibitorRows: legacyExhibitorRows,
        verificationById,
        isTaskLoading: false,
        taskLoadError:
          candidates.length === 0
            ? "The tracker returned no result sets."
            : null,
      });
    } catch (err) {
      console.error("Error in getVendorTaskList:", err);
      this.setState({
        hallZoneMasterRows: [],
        stallHomes: new Map(),
        servicePartnerRows: [],
        exhibitorOrderRows: [],
        dailyRoutineRows: [],
        stallPossessionRows: [],
        taskRows: [],
        exhibitorRows: [],
        isTaskLoading: false,
        taskLoadError: `Tracker request errored: ${err && err.message ? err.message : err}`,
      });
    }
  }

  // keepZoneId: a zone id to leave selected once the fetch settles, instead
  // of the usual reset to "". Used only by handleZoneStallFocus, so a stall
  // clicked straight on the Zone map keeps its zone selected through the
  // refetch this triggers, rather than being cleared a moment later.
  getZoneData(svgHallId, keepZoneId = "") {
    if (!svgHallId) {
      this.setState({ zoneData: [], zoneStalls: [], selectedZoneId: "", zoneError: null, isZoneLoading: false });
      return;
    }

    const dbHallId = this.resolveDbHallId(svgHallId);
    if (dbHallId == null) {
      const hall = this.state.svgHalls.find((h) => h.HallID === svgHallId);
      this.setState({
        zoneData: [],
        zoneStalls: [],
        selectedZoneId: keepZoneId,
        isZoneLoading: false,
        zoneError: `"${hall ? hall.HallName : svgHallId}" is in the layout drawing but has no matching hall record, so zones could not be loaded.`,
      });
      return;
    }

    this.setState({ isZoneLoading: true, zoneError: null });
    this.props
      .getZoneData_action(dbHallId)
      .then((res) => {
        // Ignore a response for a hall the user has already moved away from.
        if (this.state.filterHallId !== svgHallId) return;
        if (res && res.error === 0) {
          // data  = zones for the hall, data2 = the stalls inside each zone.
          // Keep only this hall's rows: the dropdown must not offer another
          // hall's "Zone 1", and its stalls must not join this hall's zones.
          const ofThisHall = (row) => row.HallID == null || String(row.HallID) === String(dbHallId);
          this.setState({
            zoneData: (res.data || []).filter(ofThisHall),
            zoneStalls: (res.data2 || []).filter(ofThisHall),
            selectedZoneId: keepZoneId,
            isZoneLoading: false,
          });
        } else {
          this.setState({
            zoneData: [],
            zoneStalls: [],
            selectedZoneId: keepZoneId,
            isZoneLoading: false,
            zoneError: (res && res.msg) || "Failed to load zone data.",
          });
        }
      })
      .catch((err) => {
        console.error("Error loading zone data:", err);
        if (this.state.filterHallId !== svgHallId) return;
        this.setState({ zoneData: [], zoneStalls: [], selectedZoneId: keepZoneId, isZoneLoading: false, zoneError: "Error loading zone data." });
      });
  }

  handleFilterBoothChange = (boothId) => {
    this.setState({ filterBoothId: boothId });
  };

  // Halls/booths are read out of each layout's drawing (svgDataCallbackFor).
  // The API's booths[] carries sequential placeholder ClipIds that do not
  // correspond to the SVG, so the drawing is the source of truth for what can
  // actually be selected.

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data && data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
      },
      () => this.getVendorTaskList()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  render() {
    const {
      isLoading,
      isUpdateModalOpen,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
      layouts,
      selectedLayoutId,
      layoutError,
      isLayoutLoading,
      filterHallId,
      filterBoothId,
      grid,
      viewFilter,
      dataFilters,
      hallZoneMasterRows,
      stallHomes,
      servicePartnerRows,
      exhibitorOrderRows,
      dailyRoutineRows,
      stallPossessionRows,
      taskRows,
      exhibitorRows,
      isTaskLoading,
      taskLoadError,
      svgHalls,
      zoneData,
      zoneStalls,
      selectedZoneId,
      isZoneLoading,
      zoneError,
      verificationById,
      isHallManagerRole,
      showTaskModal,
      taskModalFilter,
      isManualFormModalOpen,
      manualFormService,
      manualFormExhibitor,
    } = this.state;

    // eslint-disable-next-line no-unused-vars
    const selectedLayout = layouts.find(l => l.MstHallLayoutID === selectedLayoutId);

    // The legend counts booths, because that is what the map draws. Both read
    // the same StallTaskStatus the procedure grades each stall with, so the
    // legend and the drawing can never tell different stories.
    const STALL_TASK_STATUS = {
      1: "Completed",
      2: "InProgress",
      3: "Pending",
      4: "Delayed",
    };
    const seenStalls = new Set();
    const effectiveExhibitorRows = (servicePartnerRows && servicePartnerRows.length > 0) ? servicePartnerRows : exhibitorRows;
    const statusCounts = effectiveExhibitorRows.reduce((acc, row) => {
      const stall = String(row.StallName || row.Stall || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
      if (!stall || seenStalls.has(stall)) return acc;
      seenStalls.add(stall);
      const raw = Array.isArray(row.StallTaskStatus)
        ? row.StallTaskStatus.find((v) => v != null)
        : row.StallTaskStatus;
      // 5, and anything the procedure does not grade, is an unallocated stall.
      const key = STALL_TASK_STATUS[Number(raw)] || (typeof raw === "string" ? raw : null);
      if (!key) return acc;
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});


    // ─── One layout at a time, chosen by hall ───
    const { svgDataByLayout, svgLoadingIds, renderReadyId, largeSvgPrompt, pendingHall, showAllLayouts, statusCountsByLayout } = this.state;
    const isVenueView = viewFilter === "venue" || viewFilter === "venueZone";
    const shownLayout = layouts.find((l) => l.MstHallLayoutID === selectedLayoutId) || null;
    const shownSvgData = shownLayout ? svgDataByLayout[shownLayout.MstHallLayoutID] : null;
    const hallSort = (a, b) => String(a.HallName).localeCompare(String(b.HallName), undefined, { numeric: true });
    // Every mapped hall of every layout. The shown layout's halls carry their
    // drawing ids; the others a "pending:<layout>:<name>" value that switches
    // layout when picked.
    const pendingValue = (layoutId, name) => `pending:${layoutId}:${name}`;
    // Grouped by layout: the layout itself first ("layout:<id>" - the whole
    // drawing, unzoomed; it replaces "All Halls", since no drawing has every
    // hall), then its halls.
    // "All Halls" first (every layout, stacked); then each layout and its halls.
    // With All Halls on, every hall carries a pending value: picking one goes
    // back to that single layout and focuses the hall.
    // A hall sits in exactly one drawing, so it is listed once - under the
    // layout that owns it. The layout mapping (getHallLayout's halls) can name
    // a hall under several layouts; the owner is, in order:
    //   1. the layout whose LOADED drawing contains the hall;
    //   2. the layout whose name carries the hall's number ("Halls 14, 15");
    //   3. the layout mapped to the fewest halls (the most specific);
    //   4. the first layout mapped to it.
    const hallKeyOf = (name) => String(name || "").trim().toLowerCase().replace(/\s+/g, " ");
    const numbersIn = (text) => (String(text || "").match(/\d+/g) || []).map(Number);
    const candidates = new Map(); // hall key -> { name, layouts: [] }
    const addCandidate = (name, layout) => {
      const k = hallKeyOf(name);
      if (!k) return;
      if (!candidates.has(k)) candidates.set(k, { name, layouts: [] });
      const c = candidates.get(k);
      if (!c.layouts.includes(layout)) c.layouts.push(layout);
    };
    const drawnIn = new Map(); // hall key -> layout id whose drawing has it
    layouts.forEach((l) => {
      const data = svgDataByLayout[l.MstHallLayoutID];
      ((data && data.halls) || []).forEach((h) => {
        const k = hallKeyOf(h.HallName);
        if (k && !drawnIn.has(k)) drawnIn.set(k, l.MstHallLayoutID);
      });
      (l.halls || []).forEach((h) => addCandidate(h.HallName, l));
    });
    const ownerOf = new Map(); // hall key -> owning layout id
    candidates.forEach(({ name, layouts: ls }, k) => {
      if (drawnIn.has(k)) { ownerOf.set(k, drawnIn.get(k)); return; }
      const nums = numbersIn(name);
      const hallNo = nums.length === 1 ? nums[0] : null;
      const named = hallNo == null ? [] : ls.filter((l) => numbersIn(l.LayoutName).includes(hallNo));
      const pool = named.length > 0 ? named : ls;
      const pick = pool.reduce((best, l) => ((l.halls || []).length < (best.halls || []).length ? l : best), pool[0]);
      ownerOf.set(k, pick.MstHallLayoutID);
    });
    drawnIn.forEach((id, k) => { if (!ownerOf.has(k)) ownerOf.set(k, id); });
    const listedHalls = new Set();
    const hallOptions = [{ HallID: "all", HallName: "All Halls", BoothCount: null }].concat(layouts.flatMap((l) => {
      const fromDrawing = shownSvgData && l.MstHallLayoutID === selectedLayoutId && !showAllLayouts;
      const halls = (fromDrawing
        ? (shownSvgData.halls || []).slice()
        : (l.halls || [])
          .map((h) => ({ HallID: pendingValue(l.MstHallLayoutID, h.HallName), HallName: h.HallName, BoothCount: null }))
      )
        .filter((h) => {
          const k = hallKeyOf(h.HallName);
          if (!k || listedHalls.has(k)) return false;
          if (!fromDrawing && ownerOf.has(k) && ownerOf.get(k) !== l.MstHallLayoutID) return false;
          listedHalls.add(k);
          return true;
        })
        .sort(hallSort);
      return [{ HallID: `layout:${l.MstHallLayoutID}`, HallName: l.LayoutName, BoothCount: null }, ...halls];
    }));
    const toolbarHallValue = showAllLayouts
      ? "all"
      : pendingHall
        ? pendingValue(pendingHall.layoutId, pendingHall.name)
        : filterHallId || (selectedLayoutId != null ? `layout:${selectedLayoutId}` : "");

    const sizeMb = (l) => (l.svgFileSize > 0 ? `${(l.svgFileSize / (1024 * 1024)).toFixed(1)} MB` : "");
    const hallSwitcher = (
      <select
        className="form-select layout-view-select d-inline-block mt-3"
        style={{ width: "auto", minWidth: "180px", fontSize: "13px", height: "32px", paddingTop: 0, paddingBottom: 0 }}
        value={toolbarHallValue || ""}
        onChange={(e) => this.handleFilterHallChange(e.target.value)}
        title="Pick another hall"
      >
        {hallOptions.map((h) => (
          <option key={h.HallID} value={h.HallID}>{h.HallName}</option>
        ))}
      </select>
    );
    const renderLayoutLoader = (layout) => {
      const id = layout.MstHallLayoutID;
      return (
        <div className="bg-white p-5 rounded border text-center my-2">
          <div className="fw-semibold mb-2" style={{ color: "#007062" }}>
            <i className="ri-map-2-line me-1"></i>{layout.LayoutName}
          </div>
          {layout.svgFileExists === false ? (
            <small className="text-danger d-block">The drawing ({layout.LayoutFilePath}) is not on the server.</small>
          ) : largeSvgPrompt === id ? (
            <>
              <div className="text-warning mb-2"><i className="ri-error-warning-line" style={{ fontSize: "28px" }}></i></div>
              <h6 className="fw-semibold text-dark mb-1 text-center w-100">This drawing is large ({sizeMb(layout)})</h6>
              <small className="text-muted d-block mb-3">
                Opening it can make the page stop responding for a while. Load it now, or pick a hall on another layout.
              </small>
              <button type="button" className="btn btn-sm btn-primary" onClick={() => this.loadLayoutSvg(id, { force: true })}>
                Load drawing
              </button>
            </>
          ) : (svgLoadingIds || []).includes(id) ? (
            <>
              <div className="spinner-border text-primary mb-2" role="status" />
              <h6 className="fw-semibold text-dark mb-1 text-center w-100">Loading Layout...</h6>
              {sizeMb(layout) && <small className="text-muted d-block">Drawing size {sizeMb(layout)}</small>}
            </>
          ) : layout.svgContent ? (
            <>
              <div className="spinner-border text-primary mb-2" role="status" />
              <h6 className="fw-semibold text-dark mb-1 text-center w-100">Preparing the drawing...</h6>
              <small className="text-muted d-block">The page may pause briefly while the booths are read.</small>
            </>
          ) : (
            <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.loadLayoutSvg(id, { force: true })}>
              Load {layout.LayoutName}
            </button>
          )}
          <div>{hallSwitcher}</div>
        </div>
      );
    };

    // All Halls: the legend shows every shown layout's counts added up.
    const reportedCounts = Object.values(statusCountsByLayout || {}).filter(Boolean);
    const summedCounts = showAllLayouts && !isVenueView && reportedCounts.length > 1
      ? reportedCounts.reduce((acc, c) => {
        Object.entries(c).forEach(([k, v]) => { acc[k] = (acc[k] || 0) + (Number(v) || 0); });
        return acc;
      }, {})
      : null;

    const renderLayoutCanvas = (layout, { primary = true, children = null } = {}) => (
      <SvgCanvas
        key={layout.MstHallLayoutID}
        layout={layout}
        compact={!primary}
        legendCounts={primary ? summedCounts : null}
        onStatusCountsChange={this.statusCountCallbackFor(layout.MstHallLayoutID)}
        viewFilter={viewFilter}
        dataFilters={dataFilters}
        onViewFilterChange={this.handleViewFilterChange}
        onDataFilterChange={this.handleDataFilterChange}
        hallZoneMasterRows={hallZoneMasterRows}
        stallHomes={stallHomes}
        servicePartnerRows={servicePartnerRows}
        exhibitorOrderRows={exhibitorOrderRows}
        dailyRoutineRows={dailyRoutineRows}
        stallPossessionRows={stallPossessionRows}
        deliverableRows={this.state.deliverableRows}
        filterHallId={filterHallId}
        filterBoothId={filterBoothId}
        onFilterHallChange={this.handleFilterHallChange}
        onFilterBoothChange={this.handleFilterBoothChange}
        onSvgDataExtracted={this.svgDataCallbackFor(layout.MstHallLayoutID)}
        hallOptions={hallOptions}
        hideAllHallsOption
        toolbarHallId={toolbarHallValue}
        zones={zoneData}
        selectedZoneId={selectedZoneId}
        onZoneChange={this.handleZoneChange}
        onZoneStallFocus={this.handleZoneStallFocus}
        isZoneLoading={isZoneLoading}
        zoneStalls={zoneStalls}
        statusCounts={statusCounts}
        isStatusLoading={isTaskLoading}
        taskRows={taskRows}
        exhibitorRows={effectiveExhibitorRows}
        isTaskLoading={isTaskLoading}
        taskLoadError={taskLoadError}
        services={serviceList}
        selectedServiceId={serviceId}
        onServiceChange={this.handleServiceChange}
        verificationById={verificationById}
        onOpenTaskDetail={this.handleOpenTaskDetail}
        onOpenDailyRoutine={this.handleOpenDailyRoutine}
        onOpenManualForm={this.handleOpenManualForm}
      >
        {children}
      </SvgCanvas>
    );

    // One layout, or with All Halls every layout stacked: the first carries the
    // toolbar and legend, the rest render compact inside it (so Full Screen
    // holds them). Venue views draw the whole venue - shown once.
    const stackedOthers = showAllLayouts && !isVenueView && shownLayout
      ? layouts
        .filter((l) => l.MstHallLayoutID !== shownLayout.MstHallLayoutID)
        .map((l) => (
          <div key={l.MstHallLayoutID}>
            {l.svgContent ? renderLayoutCanvas(l, { primary: false }) : renderLayoutLoader(l)}
          </div>
        ))
      : null;
    const stackedLayouts = !shownLayout
      ? null
      : shownLayout.svgContent && renderReadyId === shownLayout.MstHallLayoutID
        ? renderLayoutCanvas(shownLayout, { children: stackedOthers })
        : (
          <>
            {renderLayoutLoader(shownLayout)}
            {stackedOthers}
          </>
        );

    return (
      <>
        <ToastContainer />
        {RoleID == 16 && <HeaderWithLogo />}
        {/* <ExhibitorDrawer /> */}
        <>
          {/* <AdminDrawer /> */}
          {/*app-content open*/}
          <div
            className="app-content with-dr-container com-height admin-top-space"
            style={{ marginLeft: 0 }}
          >
            <main id="main" className={RoleID == 16 ? "px-3" : "px-1"}>
              <section className="section" style={{ padding: 0 }}>
                {/* Layout SVG Display Section */}
                {layoutError && (
                  <div className="alert alert-info alert-dismissible fade show mb-4" role="alert">
                    <i className="ri-information-line me-2"></i>
                    {layoutError}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => this.setState({ layoutError: null })}
                    ></button>
                  </div>
                )}

                {/* ─── Container for Hall Layout View ─── */}
                <div className="layout-view-container mb-5 p-2" style={{ backgroundColor: '#f3f4f7' }}>


                  {isLayoutLoading ? (
                    <div className="bg-white p-5 rounded border text-center my-2">
                      <div className="spinner-border text-primary mb-3" style={{ width: "2.5rem", height: "2.5rem" }} role="status">
                        <span className="visually-hidden">Loading layout...</span>
                      </div>
                      <h6 className="fw-semibold text-dark mb-1">Loading Hall Layout Map...</h6>
                      <small className="text-muted d-block mb-3">Please wait while interactive layout SVG and booth allocations load.</small>

                      {/* Skeleton placeholders for mapped hall cards */}
                      <div className="mt-4 pt-3 border-top">
                        <small className="text-muted d-block text-start mb-2 fw-semibold">Mapped Halls Skeleton:</small>
                        <div className="row">
                          {[1, 2, 3].map((i) => (
                            <div key={i} className="col-md-6 col-lg-4 mb-3">
                              <div className="card shadow-sm border-0 bg-light p-3 text-start">
                                <div className="placeholder-glow">
                                  <span className="placeholder col-8 bg-secondary mb-2 rounded"></span>
                                  <span className="placeholder col-4 bg-secondary-subtle d-block rounded"></span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : layouts.length > 0 ? (
                    <>
                      {/* All layouts, one below the other. The first one's toolbar
                          and legend drive every layout; each canvas shows a loader
                          until its drawing has arrived. */}
                      <div className="layout-canvas-wrapper">
                        {stackedLayouts}
                      </div>

                      {zoneError && (
                        <div className="alert alert-warning d-flex align-items-center py-2 px-3 mt-3 mb-0 small" role="alert">
                          <i className="ri-error-warning-line me-2"></i>
                          {zoneError}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="alert alert-secondary mb-0" role="alert">
                      <i className="ri-information-line me-2"></i>No hall layouts available for this exhibition.
                    </div>
                  )}
                </div>



                {/* The full task screen, over the map. Rendered only while open
                    so it mounts fresh and its poll stops on close. */}
                <Modal
                  isOpen={showTaskModal}
                  onRequestClose={this.closeTaskModal}
                  ariaHideApp={false}
                  style={{
                    overlay: { zIndex: 1050, backgroundColor: "rgba(0,0,0,0.5)" },
                    content: {
                      inset: "2vh 2vw",
                      padding: 0,
                      border: "none",
                      background: "transparent",
                      overflow: "hidden",
                    },
                  }}
                >
                  <div className="modal-content" style={{ height: "96vh", display: "flex", flexDirection: "column" }}>
                    <div className="modal-header py-3 text-white">
                      <h6 className="mb-0">
                        <i className="ri-list-check-2 me-2"></i>
                        Tasks
                        {taskModalFilter && taskModalFilter.hallName
                          ? ` — ${taskModalFilter.hallName}`
                          : ""}
                        {taskModalFilter && taskModalFilter.serviceName
                          ? ` · ${taskModalFilter.serviceName}`
                          : ""}
                        {taskModalFilter && taskModalFilter.vendorCompany
                          ? ` · ${String(taskModalFilter.vendorCompany).trim()}`
                          : ""}
                      </h6>
                      <button
                        type="button"
                        className="btn-close ms-auto"
                        onClick={this.closeTaskModal}
                      ></button>
                    </div>
                    <div className="modal-body" style={{ overflowY: "auto", flex: 1 }}>
                      {showTaskModal && (
                        <VendorTaskDetail embedded taskFilter={taskModalFilter} />
                      )}
                    </div>
                  </div>
                </Modal>

                {/* A daily routine from a popup, in the Daily Routine Task
                    update screen (edit mode), one occurrence at a time. */}
                <Modal
                  isOpen={!!this.state.routineModal}
                  onRequestClose={() => this.closeRoutineModal(false)}
                  ariaHideApp={false}
                  style={{
                    overlay: { zIndex: 1050, backgroundColor: "rgba(0,0,0,0.5)" },
                    content: {
                      inset: "2vh 2vw",
                      padding: 0,
                      border: "none",
                      background: "transparent",
                      overflow: "hidden",
                    },
                  }}
                >
                  {this.state.routineModal && (() => {
                    const { row, loading, occurrences, pick, error } = this.state.routineModal;
                    const picked = occurrences[pick] || null;
                    return (
                      <div className="modal-content" style={{ height: "96vh", display: "flex", flexDirection: "column" }}>
                        <div className="modal-header py-3 text-white">
                          <h6 className="mb-0">
                            <i className="ri-calendar-check-line me-2"></i>
                            Daily Routine Task — {row.ProgramTitle}
                            {row.HallName ? ` · ${row.HallName}` : ""}
                          </h6>
                          {occurrences.length > 1 && (
                            <select
                              className="form-select form-select-sm ms-3"
                              style={{ width: "auto", maxWidth: "260px" }}
                              value={pick}
                              title="Date and schedule time"
                              onChange={(e) => this.setState({ routineModal: { ...this.state.routineModal, pick: Number(e.target.value) } })}
                            >
                              {occurrences.map((o, i) => (
                                <option key={`${o.DailyRoutineChecklistDateID}|${o.DailyRoutineChecklistScheduleTimeID}|${o.DailyRoutineChecklistHallID}`} value={i}>
                                  {o.ChecklistDate ? moment(o.ChecklistDate).format("DD/MM/YYYY") : "--"} · {o.FromTime || ""}{o.ToTime ? ` - ${o.ToTime}` : ""}{o.Status ? ` (${o.Status})` : ""}
                                </option>
                              ))}
                            </select>
                          )}
                          <button type="button" className="btn-close ms-auto" onClick={() => this.closeRoutineModal(false)}></button>
                        </div>
                        <div className="modal-body" style={{ overflowY: "auto", flex: 1 }}>
                          {loading ? (
                            <div className="text-muted p-3">
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>Loading schedule...
                            </div>
                          ) : !picked ? (
                            <div className="text-muted fst-italic p-3">
                              {error || `No scheduled occurrence of "${row.ProgramTitle}" found for ${row.HallName || "this hall"}.`}
                            </div>
                          ) : (
                            <DailyRoutineTaskUpdate
                              // A different occurrence mounts the screen fresh.
                              key={`${picked.DailyRoutineChecklistHdrID}|${picked.DailyRoutineChecklistHallID}|${picked.DailyRoutineChecklistDateID}|${picked.DailyRoutineChecklistScheduleTimeID}`}
                              embedded
                              routineState={this.routineStateOf(picked)}
                              onDone={(saved) => this.closeRoutineModal(saved)}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })()}
                </Modal>

                {/* Manual form for one service of one exhibitor. Rendered only
                    while open so each opening mounts the form fresh, after
                    ExhRegistrationIDSS has been set. */}
                <Modal
                  isOpen={isManualFormModalOpen}
                  onRequestClose={() => this.setState({ isManualFormModalOpen: false })}
                  shouldCloseOnEsc={true}
                  shouldCloseOnOverlayClick={true}
                  ariaHideApp={false}
                >
                  <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                      <div className="modal-header p-2">
                        <h6 className="modal-title">
                          {manualFormService || "Manual Form"}
                          {manualFormExhibitor ? ` — ${manualFormExhibitor}` : ""}
                        </h6>
                      </div>
                      <div className="modal-body">
                        {isManualFormModalOpen && this.renderManualForm(manualFormService)}
                      </div>
                      <div className="modal-footer py-1">
                        <button
                          className="btn btn-gray"
                          onClick={() => this.setState({ isManualFormModalOpen: false })}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal>
              </section>
            </main>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getLayoutViewAuditTrackerList_action,
    getLayoutTrackerData_action,
    getZoneData_action,
    getVendorTaskList_action,
    fetchDRTList_action,
  })(LayoutView)
);
